import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { WorkflowChangeRequest } from "@idw-types/data/workflow-change-request";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";
import { CancelWorkflowChangeRequestBody } from "./cancel-workflow-change-request-body";

type CancelWorkflowChangeRequestModalProps = {
    workflowName: string;
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<WorkflowChangeRequest>;
};

export const CancelWorkflowChangeRequestModal = (props: CancelWorkflowChangeRequestModalProps) => {
    const { workflowName, onModalClose, onSubmitHandler } = props;

    const onSubmit = async (onModalClose: () => void) => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.CANCEL}
            title={"Cancel Verification Workflow Change Request"}
            body={<CancelWorkflowChangeRequestBody workflowName={workflowName} />}
            buttonText={"Cancel Change Request"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};